<template>
  <div class="md-layout">
    Bonjour
    <div
      @click="goToDisplay(t)"
      :key="t.title"
      v-for="t in getAllToolsBoxList"
      class="md-layout-item"
    >{{t.title}}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// @ is an alias to /src

export default {
  name: "toolbox",
  components: {},
  methods: {
    goToDisplay(t) {
      this.$router.push({ name: "toolboxdisplay", params: { tool: t } });
    }
  },
  computed: {
    ...mapGetters(["getAllToolsBoxList"])
  }
};
</script>

<style >
.home {
}
</style>
